export default "__VITE_ASSET__DG2TQxLW__"